import { render, staticRenderFns } from "./LatestCommunicationsDialog.vue?vue&type=template&id=69120e85&scoped=true"
import script from "./LatestCommunicationsDialog.vue?vue&type=script&lang=js"
export * from "./LatestCommunicationsDialog.vue?vue&type=script&lang=js"
import style0 from "./LatestCommunicationsDialog.vue?vue&type=style&index=0&id=69120e85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69120e85",
  null
  
)

export default component.exports